import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
// import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";
/**
 * Interface describing a Public Subnet.
 * Adjust as needed if your backend has more/less fields.
 */
export interface PublicSubnet {
	id: number;
	ip: string;
	mask: string; // e.g. "34"
	status: string; // e.g. "assigned", "available", etc.
	ipBlockId: number;
	ipBlock?: {
		name: string; // from the example: "ipBlock": { "name": "IPX01" }
	};
}

/**
 * Table columns for the GenericTable
 * Adjust or remove columns if you want a simpler view.
 */
export const columns: GenericTableColumn<PublicSubnet>[] = [
	{
		header: "IP",
		accessor: "ip",
	},
	{
		header: "Mask",
		accessor: "mask",
	},
	{
		header: "Status",
		accessor: "status",
	},
	{
		header: "IP Block",
		renderCell: (row) => (row.ipBlock ? row.ipBlock.name : ""),
	},
	{
		header: "Actions",
		// We'll override the rendering of this column in the Inventory Page
		accessor: "id", // or just some placeholder
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View data center:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit data center:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>
			</div>
		),
	},
];
